import React from 'react';
import { Box, Skeleton } from '@mui/material';
const DealCardSkeletonV2 = () => {
  return (
    <Box sx={{ width: '100%', flexDirection: 'column' }}>
      {/* Image section */}
      <Box  sx={{ width: '100%', height: 220, mb: 2 }}>
        <Skeleton variant="rectangular" width="100%" height="100%" />
      </Box>

      {/* Value section */}
      <Box  display="flex" alignItems="center" gap={1} mb={1}>
        <Skeleton variant="text" width={80} height={30} />
        <Skeleton variant="text" width={60} height={25} />
      </Box>

      {/* Info section */}
      <Box  sx={{ width: '100%' }}>
        <Skeleton variant="text" width="40%" height={20} sx={{ mb: 1 }} /> {/* Tagline */}
        <Skeleton variant="text" width="80%" height={28} sx={{ mb: 1 }} /> {/* Title */}
        <Skeleton variant="text" width="90%" height={20} sx={{ mb: 1 }} /> {/* Description */}

        {/* Button placeholder */}
        <Box>
          <Skeleton variant="rectangular" width={100} height={36} sx={{ borderRadius: 2 }} />
        </Box>
      </Box>
    </Box>
  );
};

export { DealCardSkeletonV2 };
